import React, { PureComponent, ReactNode } from 'react';
import { GridElement } from './types';

interface SheetProps {
  className?: string;
  data: GridElement[];
  children?: ReactNode;
}

export class Sheet extends PureComponent<SheetProps> {
  render() {
    return (
            <table className={this.props.className}>
                <tbody>{this.props.children}</tbody>
            </table>
    );
  }
}
